// extracted by mini-css-extract-plugin
export default {"body":"RestoreEmailSent_body__6aEjr","title":"RestoreEmailSent_title__H9SG1","subtitle":"RestoreEmailSent_subtitle__lSOp0"};